import { makeStyles } from '@material-ui/core/styles';
import { SITE_IMPORT_STATUSES } from './SiteAdminConstants';

export const VERSION_LABEL_CLASS = 'versionLabel';
export const VERSION_LABEL_INFO_CLASS = 'versionLabelInfo';
export const VERSION_LABEL_WARNING_CLASS = 'versionLabelWarning';
export const VERSION_LABEL_ERROR_CLASS = 'versionLabelError';
export const MATCHING_AGENTS_CONTAINER_CLASS = 'matchingAgentsContainer';
export const MORE_AGENTS_ICON_CLASS = 'moreAgentsIcon';

export const useStyles = makeStyles((theme) => ({
    siteImportButtonContainer: {
        marginBottom: theme.spacing(5),
    },
    statusContainer: {
        [`& .${SITE_IMPORT_STATUSES.SUCCESS}`]: {
            color: theme.palette.status.green,
        },

        [`& .${SITE_IMPORT_STATUSES.PARTIAL_SUCCESS}`]: {
            color: theme.palette.status.orange,
        },

        [`& .${SITE_IMPORT_STATUSES.FAILED}`]: {
            color: theme.palette.status.red,
        },
    },
    statusTextContainer: {
        fontSize: '14px',
        fontWeight: 'Bold',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
}));

export const useColumnStyles = makeStyles((theme) => ({
    root: {
        [`& .${MATCHING_AGENTS_CONTAINER_CLASS}`]: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.alignItemsCenter,
            [`& .${MORE_AGENTS_ICON_CLASS}`]: {
                paddingLeft: 10,
                '& svg': {
                    ...theme.mixins.flex.displayFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    fontSize: 18,
                },
            },
        },
    },
    siteImportButtonContainer: {
        marginBottom: theme.spacing(5),
    },
}));

// theme.palette.alert.info
